import styled from '@emotion/styled';
import ReactImageMagnify from 'react-image-magnify';

export const ImageMagnify = styled(ReactImageMagnify)({});
